import { IconButton, IIconProps, Stack } from '@fluentui/react';
import * as React from 'react';
import { IAutocompletePickerOption } from '../../data-types/autocomplete/IAutocompletePickerOption';

export interface ISelectedAutocompleteItemProps {
    styles?: React.CSSProperties;
    item: IAutocompletePickerOption;
    index: number;
    onRemoveItem?: () => void;
    removeButtonAriaLabel?: string;
    removeButtonIconProps?: IIconProps;
    disabled?: boolean;
}

export const SelectedAutocompleteItem = (props: ISelectedAutocompleteItemProps) => {
    const itemId = props.item.key;

    return (
        <div role="listitem" style={{ display: 'flex', width: props.styles?.width }}>
            <Stack horizontal style={props.styles}>
                <Stack.Item
                    grow={2}
                    id={'selectedItemAuto-' + itemId}
                    style={{ padding: 5, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
                >
                    {props.item.label}
                </Stack.Item>
                <IconButton
                    id={`${itemId}`}
                    onClick={props.onRemoveItem}
                    disabled={props.disabled}
                    style={{ height: 30, marginRight: 3 }}
                    iconProps={
                        props.removeButtonIconProps ?? {
                            iconName: 'Cancel',
                            styles: { root: { fontSize: '12px' } },
                        }
                    }
                    ariaLabel={props.removeButtonAriaLabel}
                    aria-labelledby={`${itemId} selectedItemAuto-${itemId}`}
                    data-selection-index={props.index}
                />
            </Stack>
        </div>
    );
};
